import React, { useState, useEffect } from "react";
import { array, string, object } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";

import LiveBlogStoryCard from "../../../molecules/LiveBlogStoryCard";
import CardImage from "../../../atoms/CardImage";
import NewsHeadline from "../../../atoms/NewsHeadline";
import StoryMetaData from "../../../molecules/StoryMetaData";
import DfpAd from "../../../dfp-ad";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import { getKeyHighlights } from "../../../utils/utils";

import "./row1.m.css";

const Row1 = ({ stories, widgetUrl, collectionSlug, lang, liveBlogStory, adSlotId }) => {
  const keyHighlights = liveBlogStory && getKeyHighlights(liveBlogStory.cards);
  const [width, setWidth] = useState([200]);
  const [userAgent, setUserAgent] = useState(false);

  useEffect(() => {
    global.deviceWidth < 876 && setWidth([450]);
    global.navigator.userAgent.includes("Mobile") && setUserAgent(true);
  }, []);

  const defaultSecondStoryCard = () => (
    <div styleName="card-with-widget">
      {stories.length > 1 && <NewsWithNoImage story={stories[1].story} />}
      {widgetUrl && (
        <div styleName="placeholder widget">
          <iframe
            title="Prothom alo widget"
            src={widgetUrl}
            width="274"
            height="100"
            styleName="widget-iframe"
          ></iframe>
        </div>
      )}
    </div>
  );

  const renderSecondStoryCard = () => {
    if (liveBlogStory) {
      return <LiveBlogStoryCard story={liveBlogStory} keyHighlights={keyHighlights} publisherLang={lang} />;
    } else {
      return defaultSecondStoryCard();
    }
  };

  let heroImage = "";
  if (get(stories[0].story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"])) {
    heroImage = stories[0].story.alternative.home.default["hero-image"]["hero-image-s3-key"];
  } else if (stories[0].story["hero-image-s3-key"]) {
    heroImage = stories[0].story["hero-image-s3-key"];
  }

  return (
    <div styleName={`base ${heroImage ? "" : "no-image"}`}>
      <div styleName="mobile-first-story-card">
        <Link aria-label={stories[0].story.headline} href={stories[0].story.url}>
          <CardImage
            story={stories[0].story}
            imageType="image3x4"
            aspectRatio={[3, 4]}
            widths={width}
            showAlternateImage={true}
          />
        </Link>
        <NewsHeadline story={stories[0].story} cssStyleName="bigSize" />
        <div styleName="story-data">
          <StoryMetaData story={stories[0].story} />
        </div>
      </div>
      <LeftImageRightNews story={stories[0].story} showExcerpt={true} cssStyleName="bigSize" />
      {stories[1] && renderSecondStoryCard()}
      <div styleName="adslots">
        <div styleName="placeholder ad-slot">
          {userAgent && (
            <DfpAd
              adtype={lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
              collectionSlug={collectionSlug}
              layoutName="FourteenStories3Ad1Widget"
              slotId={adSlotId}
            />
          )}
        </div>
        {widgetUrl && (
          <div styleName="placeholder widget">
            <iframe title="sports widget" src={widgetUrl} width="300" height="100" styleName="widget-iframe"></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

Row1.propTypes = {
  stories: array.isRequired,
  widgetUrl: string,
  collectionSlug: string,
  lang: string,
  liveBlogStory: object,
  adSlotId: string,
};

export default Row1;
